import React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

import './index.pc.scss';

import PcBasicTemplate from 'components/templates/PcBasicTemplate';
import PcSuggestList from 'components/molecules/PcSuggestList';
import TextBox from 'components/atoms/Input/TextBox';
import PcInputLine from 'components/molecules/PcInputLine';
import PcErrorArea from 'components/molecules/PcErrorArea';
import NormalCheckBoxInput from 'components/atoms/Input/NormalCheckBoxInput';
import DropdownInput from 'components/atoms/Input/DropdownInput';
import {
  getChoiceLabel,
  getChoiceValues,
}from 'utils';

const PresentPC = ({
  corpName,
  facilityName,
  capacity,
  userName,
  tel,
  email,
  emailConf,
  zip,
  municipality,
  houseNumber,
  addressNames,
  capacityList,
  typeList,
  handleChangeCorpName,
  handleChangeFacilityName,
  handleChangeCapacity,
  handleChangeUserName,
  handleChangeTel,
  handleChangeEmail,
  handleChangeEmailConf,
  handleChangeZip,
  handleClickAddressSuggest,
  handleChangeMunicipality,
  handleChangeHouseNumber,
  onClickMainButton,
  valid,
  errorDispMap,
  isApiError,
  handleClickAddressSuggestAway,
  isOpenAddress,
  lpMode,
}) => {
  const listValues = getChoiceValues(typeList.title);
  return (
    <div className="Info">
      <PcBasicTemplate 
        path={window.location.pathname}
        onClickMainButton={onClickMainButton}
        valid={valid}
        isApiError={isApiError}
        lpMode={lpMode}
      >

        <PcInputLine title="法人名">
          <TextBox
            name="corpName"
            val={corpName}
            onChange={handleChangeCorpName}
            placeholder="株式会社リクルートスタッフィング"
            maxLength="300"
            inValid={!!errorDispMap.corpName}
          />
          <PcErrorArea message={errorDispMap.corpName} />
        </PcInputLine>

        <PcInputLine title="施設名">
          <TextBox
            name="facilityName"
            val={facilityName}
            onChange={handleChangeFacilityName}
            placeholder="Jobマ!ホーム"
            inValid={!!errorDispMap.facilityName}
            suggestText
          />
          <PcErrorArea message={errorDispMap.facilityName} />
        </PcInputLine>

        <PcInputLine title="施設種類">
          <div className="pc-facilityType">
            {listValues.map((value) => {
              const choicelabel = getChoiceLabel(typeList.title, value);
              return (
                <NormalCheckBoxInput
                  checked={typeList.typeState.includes(value)}
                  key={choicelabel}
                  id={choicelabel}
                  label={choicelabel}
                  onChange={typeList.stateOnChange}
                  value={value}
                  color="0"
                />
              );
            })}
          </div>
          <PcErrorArea message={errorDispMap.facilityType} />
        </PcInputLine>
        
        <PcInputLine title="定員規模">
          <div className="pc-capacity">
            <DropdownInput
              items={capacityList}
              selectedValue={capacity}
              onChange={handleChangeCapacity}
            />
          </div>
          <PcErrorArea message={errorDispMap.capacity} />
        </PcInputLine>

        <PcInputLine title="ご担当者名">
          <TextBox
            name="userName"
            val={userName}
            onChange={handleChangeUserName}
            placeholder="例) 山田　太郎"
            maxLength="150"
            inValid={!!errorDispMap.userName}
          />
          <PcErrorArea message={errorDispMap.userName} />
        </PcInputLine>

        <PcInputLine title="電話番号">
          <TextBox
            name="tel"
            val={tel}
            onChange={handleChangeTel}
            placeholder="03-1234-5678"
            inValid={!!errorDispMap.tel}
          />
          <PcErrorArea message={errorDispMap.tel} />
        </PcInputLine>

        <PcInputLine title="メールアドレス">
          <TextBox
            name="email"
            val={email}
            onChange={handleChangeEmail}
            placeholder="jobma@recruit.co.jp"
            maxLength="100"
            inValid={!!errorDispMap.email}
          />
          <PcErrorArea message={errorDispMap.email} />
        </PcInputLine>
        <PcInputLine title="メールアドレス(確認)">
          <TextBox
            name="emailConf"
            val={emailConf}
            onChange={handleChangeEmailConf}
            placeholder="jobma@recruit.co.jp"
            maxLength="100"
            inValid={!!errorDispMap.emailConf}
          />
          <PcErrorArea message={errorDispMap.emailConf} />
        </PcInputLine>

        <PcInputLine
          title="郵便番号"
          optional="true"
        >
          <span className="pc-zip">
            <TextBox
              name="zip"
              val={zip}
              onChange={handleChangeZip}
              placeholder="104-8001"
              maxLength="8"
              inValid={!!errorDispMap.zip}
              suggestText
            />
          </span>
          <PcErrorArea message={errorDispMap.zip} />
        </PcInputLine>

        <OutsideClickHandler onOutsideClick={handleClickAddressSuggestAway}>
          <div className="searchNamesWrapper">
            <div className="searchNames">
              {isOpenAddress && ( 
                <PcSuggestList
                  items={addressNames}
                  onClick={handleClickAddressSuggest}
                  fullWidth
                />
              )}
            </div>
          </div>
        </OutsideClickHandler>

        <PcInputLine title="市区町村">
          <TextBox
            name="municipality"
            val={municipality}
            onChange={handleChangeMunicipality}
            placeholder="東京都中央区銀座8丁目"
            maxLength="100"
            inValid={!!errorDispMap.municipality}
          />
          <PcErrorArea message={errorDispMap.municipality} />
        </PcInputLine>

        <PcInputLine title="番地以降">
          <TextBox
            name="houseNumber"
            val={houseNumber}
            onChange={handleChangeHouseNumber}
            placeholder="4-17　リクルートGINZA8ビル"
            maxLength="100"
            inValid={!!errorDispMap.houseNumber}
          />
          <PcErrorArea message={errorDispMap.houseNumber} />
        </PcInputLine>

      </PcBasicTemplate>
    </div>
  );
};

export default PresentPC;
